// extracted by mini-css-extract-plugin
module.exports = {"restPopoverClass":"index_restPopoverClass__HcoO0"};